export const crewMemberInfoText = {
	driverDomicile: 'Driver domicile',
	phone: 'Phone',
	currentLocation: 'Current location',
	lastAssignment: 'Last assignment (current month)',
	nextAvailability: 'Next availability',
	employmentType: 'Employment Type',
	classification: 'Classification',
	workingCycle: 'Working Cycle',
	driverLicense: 'Driver License',
	medicalCheck: 'Medical check',
	scheduleAbsence: 'Schedule absence',
	changeHomeDomicile: 'Change home domicile',
	viewLog: 'View Log',
	moveToLocation: 'Move to location',
	employeeNumber: 'Employee number',
	regular: 'Regular',
	availableNow: 'Available now',
	availableSince: 'Available since',
	unavailableNext48hrs: 'Unavailable next 48hrs or location unknown',
	arrivedAt: 'arrived at',
	hoursTracking: 'Hours tracking',
	drivingBalance: 'Driving balance',
	dutyBalance: 'Duty balance',
	eightDayDuty: '8-day duty',
	drivingBalanceTooltip: 'Driving hours left before 9 hours of rest is required',
	dutyBalanceTooltip: 'Duty hours left before 9 hours of rest is required',
	eightDayDutyTooltip: 'Duty hours left in 8 days',
	hoursWarningTitle: 'Driver is out of driving or duty time.',
	hoursWarningDescription:
		'The driver is currently unavailable and cannot accept any new assignments at this time.',
	holdDown: 'Hold down',
	replacedDriver: 'Replaced driver',
	cancelReplacement: 'Cancel replacement',
	editButton: 'Edit profile',
	holdDownReplacingPrefix: 'Will be replacing ',
	holdDownReplacingFrom: ' from ',
	holdDownReplacingTo: ' to ',
};
